module.exports = __webpack_public_path__ + "static/donate_company_logo03@2x-17c60089bccb53a928f0402556cfdbac.png";